import React, { useState } from 'react'
import Timeline from '../../Mantine/Timeline'
import Botao from '../../Mantine/Botao'
import Group from '../../Mantine/Group'
import Divider from '../../Mantine/Divider'
import LineSkeleton from '../../Mantine/Skeleton/line'
import * as S from './styles'
import { format, parseISO } from 'date-fns'
import { useQuery } from 'react-query'

import { OrdersService } from '../../../services/http/orders.service'
import { useGlobal } from '../../../stores/useGlobal'

import iconBlackFC from '../../../icones/iconesVersaoEscura/circleDocument.svg'
import iconBlackPO from '../../../icones/iconesVersaoEscura/misc.svg'
import iconBlackRO from '../../../icones/iconesVersaoEscura/vehicle.svg'
import iconBlackDO from '../../../icones/iconesVersaoEscura/circleArrows.svg'
import iconBlackOEC from '../../../icones/iconesVersaoEscura/circleBox.svg'
import iconBlackBDE from '../../../icones/iconesVersaoEscura/circleCheck.svg'

import iconGreenFC from '../../../icones/iconesVersaoVerde/circleDocument.svg'
import iconGreenPO from '../../../icones/iconesVersaoVerde/misc.svg'
import iconGreenRO from '../../../icones/iconesVersaoVerde/vehicle.svg'
import iconGreenDO from '../../../icones/iconesVersaoVerde/circleArrows.svg'
import iconGreenOEC from '../../../icones/iconesVersaoVerde/circleBox.svg'
import iconGreenBDE from '../../../icones/iconesVersaoVerde/circleCheck.svg'
import iconWaiting from '../../../icones/iconesVersaoVerde/waiting.svg'

const ICONS = {
  FC: { isBlack: iconBlackFC, isGreen: iconGreenFC },
  PO: { isBlack: iconBlackPO, isGreen: iconGreenPO },
  RO: { isBlack: iconBlackRO, isGreen: iconGreenRO },
  DO: { isBlack: iconBlackDO, isGreen: iconGreenDO },
  OEC: { isBlack: iconBlackOEC, isGreen: iconGreenOEC },
  BDE: { isBlack: iconBlackBDE, isGreen: iconGreenBDE }
}

let active = 0
let heightPerItem = 90

export default function Rastreamento({ close, orderID }) {
  const { setIsLoadingGlobal } = useGlobal()

  const [tracking, setTracking] = useState(null)
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(false)

  const { getCourierTracking } = OrdersService

  useQuery(
    [`courierTracking/${orderID}`],
    async () => {
      try {
        setIsLoadingGlobal(true)
        setLoading(true)
        const track = await getCourierTracking(orderID)
        const objeto = track?.objetos?.[0]
        setTracking(objeto)

        if (!objeto?.eventos || objeto?.eventos?.length === 0) {
          active = -1 // para não setar a etapa como ativa
          heightPerItem = 120
        }
        setEvents(objeto?.eventos || [])
      } finally {
        setIsLoadingGlobal(false)
        setLoading(false)
      }
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false
    }
  )

  if (loading) {
    return (
      <S.Container>
        <Divider />
        <LineSkeleton height={305} visible />
        <Divider />
        <Group position="center">
          <Botao label="Fechar" onClick={close} />
        </Group>
      </S.Container>
    )
  }

  if (!tracking) return null

  const code = tracking.codObjeto
  const formatCode = `${code.slice(0, 2)} ${code.slice(2, 5)} ${code.slice(5, 8)} ${code.slice(8, 11)} ${code.slice(11)}`

  const formatEvents =
    events.length === 0
      ? [
          {
            title: 'Aguardando dados',
            description:
              'Ainda não há informações de rastreamento disponíveis para sua encomenda. Por favor, tente novamente mais tarde.',
            icon: iconWaiting,
            info: format(new Date(), 'dd/MM/yyyy HH:mm')
          }
        ]
      : events.map((event, idx) => {
          const isFirst = idx === 0
          const formatted = format(
            parseISO(event.dtHrCriado),
            'dd/MM/yyyy  HH:mm'
          )
          const unidade = event?.unidade
          const unidadeDestino = event?.unidadeDestino

          const description = ['RO', 'DO'].includes(event.codigo) ? (
            <>
              <div>
                de {unidade.tipo}, {unidade.endereco.cidade} -{' '}
                {unidade.endereco.uf}
              </div>
              <div>
                para {unidadeDestino.tipo}, {unidadeDestino.endereco.cidade} -{' '}
                {unidadeDestino.endereco.uf}
              </div>
            </>
          ) : event.codigo === 'FC' ? (
            <>Brasil</>
          ) : (
            `${event.unidade?.endereco?.cidade} - ${event.unidade?.endereco?.uf}`
          )

          return {
            title: event.descricao,
            description,
            line: isFirst ? undefined : 'dashed',
            icon: ICONS[event.codigo][isFirst ? 'isBlack' : 'isGreen'],
            info: formatted
          }
        })

  return (
    <S.Container>
      <Divider />
      <S.Code className="header">Código: {formatCode}</S.Code>
      <Divider />
      <Timeline
        active={active}
        events={formatEvents}
        heightPerItem={heightPerItem}
      />
      <Group position="center">
        <Botao label="Fechar" onClick={close} />
      </Group>
    </S.Container>
  )
}
